<template>
  <!-- 计费 -->
  <div class="create-order">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      class="rule-content"
    >
      <titleBlock class="title_bar" title="仓订单自动转派">
        <div class="text-wrapper">
          <!-- <span class="text1">仓订单自动转派</span> -->
          <span class="text2">开启后将仓订单将按照转仓链路自动转派给下游供应商</span>
        </div>
        <el-switch
          v-model="form.orderAssignConfig.warehouseAutoAssign"
          class="marginBottom"
          active-color="#059E84"
          inactive-color="#D9DBDE"
        />
      </titleBlock>
      <titleBlock class="title_bar_marginBottom" title="转仓链路配置">
        <template #info>
          <el-button
            class="form-btn"
            type="primary"
            plain
            size="mini"
            icon="el-icon-plus"
            @click.native.prevent="handleAdd"
          >
            新增
          </el-button>
        </template>
        <div class="transfer-link-configuration">
          <list-table-ware-house
            :table-data="tableData"
            :customers-detail="customersDetail"
            :loading="loading.fetchData"
            @fetchData="fetchData"
            @create="create"
            @refresh="hanldeRefer"
          />
        </div>
      </titleBlock>
    </el-form>

    <AddRollOverWareHouse
      ref="AddRollOverWareHouse"
      :customers-detail="customersDetail"
      @refer="hanldeRefer"
    />
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { processingSelectData } from '@/utils/index';
import { getProjectList } from '@/api/user';
import { warehouseTransferPage } from '@/api/configure/ownerRule';
import titleBlock from '../assembly/titleBlock.vue';
import AddRollOverWareHouse from '../../../configure/ownerRuleConfig/transferWarehouse/components/addRollOverWareHouse.vue';
import ListTableWareHouse from '../../../configure/ownerRuleConfig/transferWarehouse/components/listTableWareHouse.vue';
import {
  OVERTIME_TYPE,
  TIME_UNIT,
  RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE,
  CONDITION_TYPE_MAP,
  CONDITION_KIND,
  detailField,
  StarObjectList,
} from './const';
import { getConfigList } from '../api';

export default {
  components: {
    titleBlock, AddRollOverWareHouse, ListTableWareHouse,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    parentProcessName: {
      type: String,
      default: '',
    },
    parentProcessCode: {
      type: String,
      default: '',
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
    isExistWhite: {
      type: Boolean,
      default: false,
    },
    customerCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      OVERTIME_TYPE,
      CONDITION_KIND,
      detailField,
      module: 'PRICING',
      rules: {
        'orderAssignConfig.warehouseAutoAssign': [
          { required: true, message: '请选择仓订单自动转派', trigger: 'change' },
        ],
      },
      projectOptions: [],
      StarList: [],
      StarObjectList,
      // TODO:
      // chooseProjectIds: [], // 选择的运营项目

      formInfo: {},
      tableData: [
      ],
      loading: {
        fetchData: false,
      },
      total: 0,
      page: 1,
      size: 99,
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
    conditionType() {
      return processingSelectData(CONDITION_TYPE_MAP);
    },
  },
  watch: {
    // 'form.PRICING_CHECK.flag': {
    //   handler(flag) {
    //     if (flag && !this.form.PRICING_CONDITION.condition.length) {
    //       this.addOrCondition();
    //     }
    //   },
    //   immediate: true,
    // },

    // TODO:
    // 'form.STAR_CONTROL.rules': {
    //   handler(val) {
    //     if (!val || !val.length) {
    //       this.chooseProjectIds = [];
    //       return;
    //     }
    //     this.chooseProjectIds = val.map((t) => t.projectId);
    //   },
    //   immediate: true,
    // },

    customerCode: {
      handler(val) {
        if (val) {
          this.getProjectListFn();
        }
      },
      immediate: true,
    },
  },
  async created() {
    const res = await getConfigList({ keys: 'oms.star.conf', appId: '1004' });
    this.StarList = JSON.parse(res.configs?.[0].value || '[]');
    this.fetchData();
  },
  methods: {
    async getProjectListFn() {
      const data = await getProjectList({
        customerCodes: [this.customerCode],
        status: 'ENABLE',
      });
      this.projectOptions = data.length > 0 ? data.map((t) => ({
        label: t.projectName,
        value: t.id,
      })) : [];
    },
    // TODO:
    // handleAddStar() {
    //   const list = this.form.STAR_CONTROL?.rules || [];
    //   list.push({ starType: 'CAR' });
    //   this.$set(this.form.STAR_CONTROL, 'rules', list);
    // },
    // TODO:
    // handleDeleteStar(index) {
    //   const list = this.form.STAR_CONTROL.rules;
    //   list.splice(index, 1);
    //   this.$set(this.form.STAR_CONTROL, 'rules', list);
    // },
    // TODO:
    // changeProject(val, index) {
    //   const tt = this.form.STAR_CONTROL.rules[index];
    //   const proItem = this.projectOptions.find((t) => t.value === val);
    //   this.form.STAR_CONTROL.rules.splice(index, 1, {
    //     ...tt,
    //     projectName: proItem.label,
    //   });
    // },
    async valiForm() {
      await this.$refs.form.validate();
      return {
        form: cloneDeep(this.form),
      };
    },
    filterData(data) {
      const res = data.datas.map((item) => ({ ...item, projectReqs: item.projectReqs && item.projectReqs.length ? item.projectReqs.filter((pro) => pro.projectId) : [] }));
      return res;
    },
    clearValidate(prop) {
      this.$refs.form.clearValidate(prop);
    },
    addOrCondition() {
      this.$emit('addOrCondition', this.module, 'PRICING_CONDITION');
    },
    addAdnCondition(index) {
      this.$emit('addAdnCondition', index, this.module, 'PRICING_CONDITION');
    },
    Delete(value) {
      this.$emit('delete', value, this.module, 'PRICING_CONDITION');
    },
    handleOrDelete(value) {
      this.$emit('OrDelete', value, this.module, 'PRICING_CONDITION');
    },
    addTactics() {
      this.$emit('addTactics', this.module, 'PRICE_STRATEGY');
    },
    addTacticsProject(index, prop) {
      this.$emit('addTacticsProject', { index, prop }, this.module, 'PRICE_STRATEGY');
    },
    deleteTacticsProject(index, childIndex, prop) {
      this.$emit('deleteTacticsProject', { index, childIndex, prop }, this.module, 'PRICE_STRATEGY');
    },

    // 预留搜索
    async fetchData(page, size) {
      const { customerCode } = this.customersDetail;
      const data = {
        ...this.formInfo,
        // customerName: customerName || null,
        creditCodeOrCustomerCode: customerCode || null,
      };
      this.page = page || this.page;
      this.size = size || this.size;

      const params = {
        page: this.page,
        size: this.size,
        sort: 'createTime__DESC',
      };
      const res = await warehouseTransferPage(data, params);
      this.tableData = res.records.map((t) => ({
        ...t,
        ...t.ext,
        createTime: this.$dateFormatter(t.createTime),
      }));
      this.total = res.total;
    },
    handleAdd() {
      console.log('handleAdd--');
      this.$refs.AddRollOverWareHouse.init({}, false);
    },
    // TODO:新增规则 预留分配规则和上架规则
    create() {
    },
    onSearch() {
      this.page = 1;
      // this.$refs.shipperPagination.resetPage();
      this.fetchData();
    },
    hanldeRefer() {
      this.onSearch();
    },
    resetData() {
      this.formInfo = {};
      this.onSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
.create-order{
  box-sizing: border-box;
  padding:0 24px 24px;
  padding-bottom: 40px;
  ::v-deep .title_bar{
    border-bottom: 1px solid #D9DBDE;
  }
  ::v-deep .title_bar_marginBottom {
    padding-bottom: 12px;
  }
  .title-block{
    padding-top:24px;
  }
  .text-wrapper{
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
      margin-right: 8px;
    }
    .text2{
      font-size: 13px;
      color:#808792;
      // margin-left:8px;
    }
    .tip {
      margin-bottom: 24px;
    }
  }
  .new-flex{
    display:flex;
    flex-wrap:wrap;
    .second-title{
      color:#404B5C;
      margin-bottom:8px;
      width:100%;
    }
    ::v-deep .el-form-item{
      margin-right:16px;
      .el-select{
        margin-right:8px;
      }
      .el-input{
        margin-right:8px;
      }
    }
  }
  .required:before{
    content:'*';
    color:red;
  }
}
.rule_input{
  .el-input{
    width: 180px;
  }
  .rule_sign{
    margin: 0 16px;
  }
}
.addOrCondition_btn{
  cursor: pointer;
  height: 38px;
  border: 1px dashed #B3B7BE;
  font-size: 14px;
  margin-bottom: 24px;
  .el-icon-plus{
    margin-right: 10px;
  }
  &:hover{
    border-color: #51CDA6;
    color: #51CDA6;
  }
  &:focus{
    border-color: #059366;
    color: #059366;
  }
}
.danger{
  color:red;
  position: relative;
  top:30px;
}
.el-select{
  width: 100%;
}
.marginBottom{
  margin:8px 0 12px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}

.form-btn {
  margin-left: 16px;
}

.transfer-link-configuration {
  // padding: 8px;
  // border-radius: 8px;
  // border: 1px solid #D9DBDE;
  // box-sizing: border-box;
}
</style>
